import { MedicalRecordAwareFileStore } from "#/api/fileStore.type";
import Typography from "#/components/shared/typography";
import FileStoreListItem from "./FileStoreListItem";

export function FileStoreList({
  files,
}: {
  files: MedicalRecordAwareFileStore[];
}) {
  if (files.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-cream-400 bg-cream-50 p-8 text-center">
        <Typography variant="body1" className="text-brown-600">
          No files found. Upload a file or link medical records to see them
          here.
        </Typography>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {files.map((file) => (
        <FileStoreListItem key={file.id} file={file} />
      ))}
    </div>
  );
}

export default FileStoreList;
